import React, { Component } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Input, Avatar } from 'antd'
import styles from './changeBalanceDialog.module.scss'
import * as services from '@/models/managers/services'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class ChangeExtForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { submit, manager, successCallback } = this.props
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })

        return console.error(err)
      }

      services.setExt(manager._id, values)
        .then(() => {
          message.success('已设置')
          submit()
          successCallback && successCallback()
        })
        .catch(error => {
          message.error(error.message || '设置失败')
        })
    });
  }

  render() {
    const { manager } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="客服">
              <div style={{display: 'flex', alignItems: 'center'}}>
                <Avatar size={32} src={manager?.user.avatar} />
                <div style={{marginLeft: 10, fontSize: 13, color: '#b2b2b2'}}>{manager?.realname}</div>
              </div>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="分机号"
            required
            extra="* 请输入正确的分机号">
            {getFieldDecorator('number', {
              initialValue: manager?.ext,
              rules: [
                {
                  required: true,
                  message: '请输入分机号',
                },
              ],
            })(
              <Input autoFocus style={{width: 120}} placeholder="分机号" />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">设置</Button>
          </div>
        </Form>
      </div>
    )
  }
}

const ChangeBalance = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={420}
    centered
    visible={isOpen}
    onCancel={hide}>
    <ChangeExtForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'CHANGE_MANAGER_EXT_DIALOG',
 })(ChangeBalance)
